module.exports = __webpack_public_path__ + "static/img/jigoutu.5a14fda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jigoutu.png
// module id = LFAw
// module chunks = 1